import StepperDetailCourse from "../StepperDetailCourse";

const VideoList = ({
  videoData,
  selectStep,
  openQuestionFromCurrentLessonWithQuestionId,
  settingCommerce,
  isLoadingDetail,
  loadFinalResults,
  finalResultsByScheduleId,
  handleModalIframe,
}) => {
  return (
    <>
      {Object.keys(videoData).map((video, i) => {
        if (
          videoData[video]?.[0]?.link_video_palestrante == null &&
          videoData[video]?.[0]?.link_video_aula_dinamica == null
        )
          return <></>;
        const stepData = videoData[video];
        if (!!videoData[video]?.[0]?.formulario_pergunta_id) {
          loadFinalResults(videoData[video]?.[0]?.agenda_atividade_detalhe_id);
        }
        return (
          <StepperDetailCourse
            key={i}
            steps={stepData}
            selectStep={selectStep}
            openQuestionFromCurrentLessonWithQuestionId={
              openQuestionFromCurrentLessonWithQuestionId
            }
            settingCommerce={settingCommerce}
            isLoadingDetail={isLoadingDetail}
            handleModalIframe={handleModalIframe}
            finalResults={
              finalResultsByScheduleId
                ? finalResultsByScheduleId[
                    videoData[video]?.[0]?.agenda_atividade_detalhe_id
                  ]
                : []
            }
          />
        );
      })}
    </>
  );
};

export default VideoList;
